import { useEventVideoConvert } from 'entities/Attachment'
import { type MessageFieldStore } from 'widgets/MessageField'

export const useMessageFieldEventVideoConvert = (messageFieldStore: MessageFieldStore) => {
  useEventVideoConvert((data) => messageFieldStore.setConvertAttachment(data))
}
